import { combineReducers } from 'redux';
import accountReducer from './accountReducer';
import loginPageReducer from './loginPageReducer';
import dashboardReducer from './dashboardReducer';
import installerReducer from './installerReducer';
import dashboardInitialState from './init/dashboardInitialState';
import installerInitialState from './init/installerInitialState';
import accountInitialState from './init/accountInitialState';
import { guardListKeys, listSanitizer } from './guardListKeys';

// lists fetched from the API that start as null/undefined (not loaded yet); lists that start as [] are guarded anyway
const DASHBOARD_LIST_KEYS = [
    'systemsVeryShort', 'systemsNodesRoutersShort', 'devices', 'gateways', 'systemsMapsInfo', 'filesAccounts',
    'systemsForGroup', 'accountsForGroup', 'simcards', 'simcardAssignments', 'routers', 'freeSimcards',
    'routersWithSimcards', 'nodesWithSimcards', 'nodeImages', 'clients', 'inspectionPerformers',
];
const INSTALLER_LIST_KEYS = ['systemsForInstallerPanel', 'systemGroups', 'syncFailures', 'deviceErrors'];

// per state slice, also used for the persisted state when it's restored
export const LIST_SANITIZERS = {
    account: listSanitizer(accountInitialState),
    dashboard: listSanitizer(dashboardInitialState, DASHBOARD_LIST_KEYS),
    installer: listSanitizer(installerInitialState, INSTALLER_LIST_KEYS),
};

const rootReducer = combineReducers({
    account: guardListKeys(accountReducer, LIST_SANITIZERS.account),
    dashboard: guardListKeys(dashboardReducer, LIST_SANITIZERS.dashboard),
    login: loginPageReducer,
    installer: guardListKeys(installerReducer, LIST_SANITIZERS.installer)
});
export default rootReducer;
